import { apiGet, apiPost } from '../client';
import {
  BookingDetailResponseSchema,
  BookingListResponseSchema,
  BookingSchema,
  type Booking,
  type BookingDetail,
} from '../schemas';
import type { BookingWindow } from '../../lib/bookingWindows';

/**
 * The visits in `[from, to)`: each screen asks for the window it shows
 * (lib/bookingWindows), never the business's whole past on every poll.
 */
export function listBookings(window: BookingWindow): Promise<{ data: Booking[] }> {
  const query = new URLSearchParams({ from: window.from, to: window.to });
  return apiGet(`/v1/business/bookings?${query.toString()}`, BookingListResponseSchema);
}

/** One visit with its transition history; 404 for anything outside this business. */
export async function getBookingDetail(bookingId: string): Promise<BookingDetail> {
  return (
    await apiGet(
      `/v1/business/bookings/${encodeURIComponent(bookingId)}`,
      BookingDetailResponseSchema,
    )
  ).data;
}

export function completeBooking(bookingId: string, idempotencyKey: string): Promise<Booking> {
  return apiPost(
    `/v1/business/bookings/${encodeURIComponent(bookingId)}/complete`,
    BookingSchema,
    undefined,
    idempotencyKey,
  );
}

/** Front-desk check-in: only a confirmed, already-started visit qualifies. */
export function noShowBooking(bookingId: string, idempotencyKey: string): Promise<Booking> {
  return apiPost(
    `/v1/business/bookings/${encodeURIComponent(bookingId)}/no-show`,
    BookingSchema,
    undefined,
    idempotencyKey,
  );
}
